import { render, staticRenderFns } from "./NewUpdate.vue?vue&type=template&id=4f5ecd9e&scoped=true&"
import script from "./NewUpdate.vue?vue&type=script&lang=js&"
export * from "./NewUpdate.vue?vue&type=script&lang=js&"
import style0 from "./NewUpdate.vue?vue&type=style&index=0&id=4f5ecd9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ecd9e",
  null
  
)

export default component.exports